import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgClockNeverGlyphSecondary from './svgs/ClockNeverGlyphSecondary.js';
import SvgClockNeverGlyph from './svgs/ClockNeverGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var clockNeverGlyph = (props => useIcon(SvgClockNeverGlyph, SvgClockNeverGlyphSecondary, props));

export { clockNeverGlyph as default };
